Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var feedback = require('@sentry-internal/feedback');
var lazyLoadIntegration = require('./utils/lazyLoadIntegration.js');

/**
 * An integration to add user feedback to your application,
 * while loading most of the code lazily only when it's needed.
 */
var feedbackAsyncIntegration = feedback.buildFeedbackIntegration({
  lazyLoadIntegration: lazyLoadIntegration.lazyLoadIntegration
});
exports.feedbackAsyncIntegration = feedbackAsyncIntegration;